<div class="d-flex align-items-center">
    <img class="logo1 " src="../../assets/images/Top Logo.png">
    <!-- <img class="ml-3" [src]="checkIcon(commonService?.pageHeading)" *ngIf="commonService?.pageHeading !== 'Home'"
        alt=""> -->
    <!-- <p class="ml-3 pr2">{{commonService?.pageHeading || 'Earth Virtual'}}</p> -->
</div>